import { DealerData } from 'app/apiCalls/dealer';

export interface ContactFormProps {
  dealer?: Partial<DealerData>;
}

export const VALUE_OF_LEAD_IN_EUR = 20;
